export default __webpack_public_path__ + "static/media/logo-mhealth.b1ae222e.jpg";